
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/codetutor",
      function () {
        return require("private-next-pages/projects/codetutor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/codetutor"])
      });
    }
  